import { render, staticRenderFns } from "./widgetBarStackChart.vue?vue&type=template&id=2bc037a8&scoped=true&"
import script from "./widgetBarStackChart.vue?vue&type=script&lang=js&"
export * from "./widgetBarStackChart.vue?vue&type=script&lang=js&"
import style0 from "./widgetBarStackChart.vue?vue&type=style&index=0&id=2bc037a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc037a8",
  null
  
)

export default component.exports